export default str => typeof str !== 'object' && !Number.isNaN(Number(str));
